import { Container } from '@/components/Container'
import { FullPageLoader } from '@/components/FullPageLoader'
import {
  AuthPrompt,
  ForbiddenPrompt,
  LoadErrorPrompt,
  NoCardPrompt,
} from '@/components/StatusPrompts'
import { esumStore } from '@/pages/Esum/esumStore'
import { EsumErrorStatus } from '@/types/enum'

import classes from './styles.module.css'

import { OfferCard } from '../OfferCard'

export function Content() {
  if (esumStore.isLoading) {
    return <FullPageLoader minHeight="calc(100dvh - 72px)" />
  }

  if (
    esumStore.isAuthError ||
    esumStore.errorStatus === EsumErrorStatus.noAuth
  ) {
    return (
      <Container className={classes.mainContainer}>
        <AuthPrompt />
      </Container>
    )
  }

  if (esumStore.errorStatus === EsumErrorStatus.noCard) {
    return (
      <Container className={classes.mainContainer}>
        <NoCardPrompt />
      </Container>
    )
  }

  if (esumStore.errorStatus === EsumErrorStatus.forbidden) {
    return (
      <Container className={classes.mainContainer}>
        <ForbiddenPrompt />
      </Container>
    )
  }

  if (esumStore.isLoadError) {
    return (
      <Container className={classes.mainContainer}>
        <LoadErrorPrompt onRetry={() => esumStore.fetchOffer()} />
      </Container>
    )
  }

  return (
    <Container className={classes.mainContainer}>
      <OfferCard />
    </Container>
  )
}
